import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { PERMISSIONS, hasPermission } from '@helios/authz';

/** True when the signed-in principal may only use Client Launch Center. */
export function isClientLaunchPortalOnly(permissions: readonly string[]): boolean {
  if (!hasPermission(permissions, PERMISSIONS.CLIENT_LAUNCH_READ)) {
    return false;
  }
  if (hasPermission(permissions, PERMISSIONS.CLIENT_LAUNCH_MANAGE)) {
    return false;
  }
  return permissions.every((permission) => permission.startsWith('client_launch:'));
}

export const CLC_PORTAL_BASE = '/portal/launch';
export const CLC_STAFF_BASE = '/client-launch';

export function isClcPortalPath(pathname: string): boolean {
  return pathname === CLC_PORTAL_BASE || pathname.startsWith(`${CLC_PORTAL_BASE}/`);
}

export function useClcBasePath(): string {
  const location = useLocation();
  return useMemo(
    () => (isClcPortalPath(location.pathname) ? CLC_PORTAL_BASE : CLC_STAFF_BASE),
    [location.pathname],
  );
}

export function clcPath(base: string, segment = ''): string {
  if (!segment) return base;
  const cleaned = segment.replace(/^\//, '');
  return `${base}/${cleaned}`;
}
